import React, { ChangeEvent } from "react";

import ButtonNumberInput from "components/ButtonNumberInput";
import { ONLY_NUMBERS_REGEXP } from "common/regExp";
import { EMPTY_STRING } from "common/constants";
import useStyles from "./styles";

export interface IPreferenceProperty {
  title: string;
  value: number;
  onChange: (value: number) => void;
  isFacilityRepeatable?: boolean;
  maxLength?: number;
}

interface IProps {
  property: IPreferenceProperty;
}

const PreferenceProperty = (props: IProps) => {
  const { title, value, onChange, maxLength } = props.property;

  const classes = useStyles();

  const handleChangeInputValue = (
    event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    const value = event.currentTarget.value;

    if (value === EMPTY_STRING || ONLY_NUMBERS_REGEXP.test(value)) {
      onChange(Number(value));
    }
  };

  return (
    <div className={classes.preferencesProperty}>
      <span className={classes.propertyTitle}>{title}</span>
      <ButtonNumberInput
        hideButtons={true}
        wrapClassName={classes.wrapTextField}
        TextFieldProps={{
          variant: "outlined",
          InputProps: {
            classes: {
              input: classes.input
            },
            onChange: handleChangeInputValue,
            value
          },
          inputProps: {
            maxLength
          }
        }}
      />
    </div>
  );
};

export default React.memo(PreferenceProperty);
